import { render } from "./app-bar.vue?vue&type=template&id=5d546006"
import script from "./app-bar.vue?vue&type=script&lang=js"
export * from "./app-bar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__